<script lang="ts">
	import { t } from 'svelte-i18n';
	import ProjectsGallery from '@app/components/projects/ProjectsGallery.svelte';

	export let data;
	let { operations, regulation } = data;
	let title = $t('projectsPage.titlePSFP');
</script>

{#if operations}
	<ProjectsGallery {data} {title} {regulation} />
{/if}
